import { render, staticRenderFns } from "./nutrients-form.vue?vue&type=template&id=8e5ab126&scoped=true&"
import script from "./nutrients-form.vue?vue&type=script&lang=js&"
export * from "./nutrients-form.vue?vue&type=script&lang=js&"
import style0 from "./nutrients-form.vue?vue&type=style&index=0&id=8e5ab126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5ab126",
  null
  
)

export default component.exports